import React from 'react';
import SoftAuthGate from './SoftAuthGate';
import { useAuth } from '../../contexts/AuthContext';
import { CircularProgress, Box } from '@mui/material';

/**
 * withFreeToolAuth: Higher-order component that wraps a free tool page.
 *
 * If the user is authenticated, renders the tool component.
 * If not, renders a SoftAuthGate with the configured tool info.
 *
 * Usage:
 *   const ProtectedFreeKundli = withFreeToolAuth({
 *     toolName: 'Free Horoscope',
 *     toolDescription: 'Get your complete Vedic birth chart...',
 *     toolIcon: '📜',
 *   })(FreeKundli);
 */
const withFreeToolAuth = ({ toolName, toolDescription, toolIcon }) => (WrappedComponent) => {
  const FreeToolAuthWrapper = (props) => {
    const { isAuthenticated, loading } = useAuth();

    if (loading) {
      return (
        <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '60vh' }}>
          <CircularProgress />
        </Box>
      );
    }

    if (!isAuthenticated) {
      return (
        <SoftAuthGate
          toolName={toolName}
          toolDescription={toolDescription}
          toolIcon={toolIcon}
        />
      );
    }

    return <WrappedComponent {...props} />;
  };

  FreeToolAuthWrapper.displayName = `withFreeToolAuth(${WrappedComponent.displayName || WrappedComponent.name || 'Component'})`;

  return FreeToolAuthWrapper;
};

export default withFreeToolAuth;
